import { Action } from "redux";
import { Organization } from "../../../model/Organization";
import { Me } from "../../../model/Me";

export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";

export interface AuthLoginSuccessAction extends Action {
  type: typeof AUTH_LOGIN_SUCCESS;
  accessToken: string;
  organizations: Organization[];
  me: Me;
  roles: string[];
}

export const authLoginSuccessAction = (
  accessToken: string,
  organizations: Organization[],
  me: Me,
  roles: string[]
): AuthLoginSuccessAction => ({
  type: AUTH_LOGIN_SUCCESS,
  accessToken,
  organizations,
  me,
  roles,
});
